'use strict';

const isMobileWidth = require('./modules/util/isMobileWidth');
const elementInViewport = require('./modules/util/elementInViewport');
const advent = require('./advent');

const responsiveVideoElement = '.js-responsive-video';
const videoControls = '.js-responsive-video-controls';
const videoControlBtn = '.js-responsive-video-control-button';
const videoOptionsData = 'responsive-video-options';

const players = [];

function createPlayers() {
    $(responsiveVideoElement).each(function (_, videoElement) {
        const options = $(videoElement).data(videoOptionsData);

        if (!options) {
            return;
        }

        const shouldInitVideo = (
            (isMobileWidth() && !options.hideOnMobile) ||
            (!isMobileWidth() && !options.hideOnDesktop)
        ) && !options.skipOnLoad;

        if (shouldInitVideo) {
            players[options.id] = videoElement;
        }

        if (options.playWhenInView) {
            playWhenInViewport(videoElement);
        }
    });
}

function playVideo(videoElement) {
    if (!videoElement) {
        return;
    }
    $('video', videoElement)[0].play();
}

function pauseVideo(videoElement) {
    if (!videoElement) {
        return;
    }
    $('video', videoElement)[0].pause();
}

function onVideoControlClick() {
    const target = $(this).data('target');
    const controls = $(this).closest(videoControls);

    if (!$(controls).hasClass('is-playing')) {
        $(controls).removeClass('was-paused');
        $(controls).addClass('is-playing');
        playVideo(target);
        advent.pushAdventDataLayerDataWithActiveProductImageSlide('play');
    } else {
        $(controls).addClass('was-paused');
        $(controls).removeClass('is-playing');
        pauseVideo(target);
        advent.pushAdventDataLayerDataWithActiveProductImageSlide('pause');
    }
}

function playWhenInViewport(videoElement) {
    $(window).on('load scroll', function () {
        const controls = $(videoElement).find(videoControls);
        const isOpaque = $(videoElement).parent().css('opacity') == '0';

        if (elementInViewport(videoElement, 0) && !isOpaque) {
            if (!controls.hasClass('was-paused') && !controls.hasClass('is-playing')) {
                playVideo(videoElement);
                controls.addClass('is-playing');
            }
            return;
        }
        pauseVideo(videoElement);
        controls.removeClass('is-playing');
    });
}

function getVideoId(el) {
    const options = JSON.parse(JSON.stringify($(el).data('responsive-video-options')));
    return options.id;
}

function init() {
    createPlayers();

    $(videoControlBtn).on('click', onVideoControlClick);
    $(videoControlBtn).on('keyup', function (e) {
        const target = $(this).data('target');
        const controls = $(this).closest(videoControls);
        const id = getVideoId(target);

        if (typeof players[id] !== 'undefined' && e.originalEvent === KeyboardEvent) {
            if (e.which === 13 || e.which === 32) {
                if (!$(controls).hasClass('is-playing')) {
                    $(controls).removeClass('was-paused');
                    $(controls).addClass('is-playing');
                    playVideo(players[id]);
                } else {
                    $(controls).addClass('was-paused');
                    $(controls).removeClass('is-playing');
                    pauseVideo(players[id]);
                }
            }
        }
    });
}

function updateVideoSrc(videoElementID, newVideoSrc) {
    if (!videoElementID) {
        return;
    }

    const $video = $(`#${videoElementID}`);
    const $src = $('source', $video);

    if (!$video || !$video.length || !$src || !$src.length) {
        return;
    }

    if (!newVideoSrc) {
        showBlock($video, false);
        return;
    }

    const $responsiveVideo = $video.closest('.js-responsive-video');
    if ($responsiveVideo && $responsiveVideo.length) {
        const responsiveVideoOptions = $responsiveVideo.data('responsive-video-options');
        if (responsiveVideoOptions) {
            responsiveVideoOptions.src = newVideoSrc;
            $responsiveVideo.attr('data-responsive-video-options', JSON.stringify(responsiveVideoOptions));
        }
    }

    $src[0].setAttribute('src', newVideoSrc);
    $video[0].load();
    $video[0].play();
    showBlock($video, true);
}

function showBlock(videoElement, showBlock) {
    if (!videoElement) {
        return;
    }

    const $videoHolder = videoElement.closest('.js-video-holder');
    if (!$videoHolder || !$videoHolder.length) {
        return;
    }

    if (showBlock) {
        $videoHolder.removeClass('hide');
        return;
    }

    $videoHolder.addClass('hide');
}

const responsiveVideo = {
    init,
    updateVideoSrc
};

module.exports = responsiveVideo;
